export interface Params {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [param: string]: any;
}

export interface Links {
    indexPrivate(): string;
    indexPublic(): string;
    login(): string;
    vendor(): string;
    voucherPurchases(): string;
    purchaseEventDlq(): string;
    appStore(): string;
    appStoreApp(app: string): string;
    createVendor(): string;
    vendorDetails(id: number): string;
    vendorProducts(id: number): string;
    editVendor(id: number): string;
    productDetails(vendorId: number, productId: number): string;
    editProduct(vendorId: number, productId: number): string;
    facility(): string;
    facilityCreate(): string;
    facilityEdit(id: number): string;
    facilityEditDetailsForm(id: number): string;
    facilityEditLocation(id: number): string;
    tenants(): string;
    tenantDetails(id: string): string;
    tenantContract(id: string): string;
    tenantFeatures(id: string): string;
    tenantEmployees(id: string): string;
    tenantEmployee(tenantId: string, employeeId: string): string;
    tenantEmployeeDetails(tenantId: string, employeeId: string): string;
    tenantEmployeeActivities(tenantId: string, employeeId: string): string;
    tenantEmployeeFacilities(tenantId: string, employeeId: string): string;
    tenantOnboarding(): string;
    tenantUsers(id: string): string;
    reports(): string;
    fitnessServices(): string;
    users(): string;
    userDetails(id: string): string;
    userWallet(id: string): string;
    userFitnessActivities(id: string): string;
    userActivityPoints(id: string): string;
    userGoals(id: string): string;
    userFitnessApps(id: string): string;
    userAnalytics(id: string): string;
    userWalletOperationDetails(userId: string, operationId: string): string;
    privateWorkoutsVerification(): string;
    communities(): string;
    communityDetails(id: string): string;
    communityFeed(id: string): string;
    communityMembers(id: string): string;
    communityDetailsSettings(id: string): string;
    teams(communityId?: string): string;
    communityTeams(id: string): string;
    createCommunityTeam(id: string): string;
    bulkCreateCommunityTeams(id: string): string;
    teamDetails(id: string): string;
    teamFeed(id: string): string;
    teamMembers(id: string): string;
    communityChallenges(id: string): string;
    editCommunity(id: string): string;
    editCommunitySettings(id: string): string;
    editCommunityLeaderboardSettings(id: string): string;
    previewCommunityLeaderboards(id: string): string;
    createCommunity(): string;
    communityChallengeEditForm(id: string, challengeId: string): string;
    communityChallengeLeaderboard(id: string, challengeId: string): string;
    challenges(): string;
    challengeLeaderboard(challengeId: string): string;
    communityChallengeCreateForm(id: string): string;
    communityPointDefinitions(id: string): string;
    createCommunityPointDefinition(id: string): string;
    editCommunityPointDefinition(id: string, definitionId: string): string;
    activityPointsRules(): string;
    activityPointsRuleDetails(id: string): string;
    createActivityPointsRule(): string;
    editActivityPointsRule(id: string): string;
    workoutTypeRules(): string;
    createWorkoutTypeRule(): string;
    editWorkoutTypeRule(id: string): string;
    workoutTypeMappings(): string;
    calculatedMetricDefinitions(): string;
    createCalculatedMetricDefinition(): string;
    editCalculatedMetricDefinition(id: string): string;
    badges(): string;
    currencies(): string;
}

export const links: Links = {
    indexPrivate: () => '/',
    indexPublic: () => '/',
    vendor: () => '/vendors',
    voucherPurchases: () => '/vendors/purchases',
    purchaseEventDlq: () => '/purchase-event-dlq',
    appStore: () => '/app-store',
    appStoreApp: (app: string) => `/app-store/${app}`,
    createVendor: () => '/vendors/create',
    vendorDetails: (id: number) => `/vendors/${id}`,
    vendorProducts: (id: number) => `/vendors/${id}/products`,
    editVendor: (id: number) => `/vendors/${id}/edit`,
    productDetails: (vendorId: number, productId: number) =>
        `/vendors/${vendorId}/products/${productId}`,
    editProduct: (vendorId: number, productId: number) =>
        `/vendors/${vendorId}/products/${productId}/edit`,
    facility: () => '/facility',
    login: () => '/login',
    facilityCreate: () => '/facility/create',
    facilityEdit: (id: number) => `/facility/${id}`,
    facilityEditDetailsForm: (id: number) => `/facility/${id}/details`,
    facilityEditLocation: (id: number) => `/facility/${id}/location`,
    tenants: () => '/tenants',
    tenantDetails: (id: string) => `/tenant/${id}`,
    tenantContract: (id: string) => `/tenant/${id}/contract`,
    tenantFeatures: (id: string) => `/tenant/${id}/features`,
    tenantEmployees: (id: string) => `/tenant/${id}/employees`,
    tenantEmployee: (tenantId: string, employeeId: string) =>
        `/tenant/${tenantId}/employees/${employeeId}`,
    tenantEmployeeDetails: (tenantId: string, employeeId: string) =>
        `/tenant/${tenantId}/employees/${employeeId}/details`,
    tenantEmployeeActivities: (tenantId: string, employeeId: string) =>
        `/tenant/${tenantId}/employees/${employeeId}/activities`,
    tenantEmployeeFacilities: (tenantId: string, employeeId: string) =>
        `/tenant/${tenantId}/employees/${employeeId}/facilities`,
    tenantUsers: (id: string) => `/tenant/${id}/users`,
    reports: () => '/reports',
    tenantOnboarding: () => '/tenant-onboarding',
    fitnessServices: () => '/fitness-services',
    users: () => '/users',
    userDetails: (id: string) => `/users/${id}`,
    userWallet: (id: string) => `/users/${id}/wallet`,
    userFitnessActivities: (id: string) => `/users/${id}/activities`,
    userActivityPoints: (id: string) => `/users/${id}/activity-points`,
    userGoals: (id: string) => `/users/${id}/goals`,
    userFitnessApps: (id: string) => `/users/${id}/fitness-apps`,
    userAnalytics: (id: string) => `/users/${id}/flags-tool`,
    userWalletOperationDetails: (userId: string, operationId: string) =>
        `/users/${userId}/wallet/operations/${operationId}`,
    privateWorkoutsVerification: () => '/private-workout-verification',
    communities: () => '/communities',
    communityDetails: (id: string) => `/communities/${id}`,
    communityFeed: (id: string) => `/communities/${id}/feed`,
    communityMembers: (id: string) => `/communities/${id}/members`,
    communityDetailsSettings: (id: string) => `/communities/${id}/settings`,
    teams: (communityId?: string) =>
        communityId ? `/communities/${communityId}/teams` : '/communities',
    communityTeams: (id: string) => `/communities/${id}/teams`,
    createCommunityTeam: (id: string) => `/communities/${id}/teams/create`,
    bulkCreateCommunityTeams: (id: string) =>
        `/communities/${id}/teams/bulk-create`,
    teamDetails: (id: string) => `/teams/${id}`,
    teamFeed: (id: string) => `/teams/${id}/feed`,
    teamMembers: (id: string) => `/teams/${id}/members`,
    editCommunity: (id: string) => `/communities/${id}/edit`,
    editCommunitySettings: (id: string) => `/communities/${id}/edit-settings`,
    editCommunityLeaderboardSettings: (id: string) =>
        `/communities/${id}/edit-leaderboard-settings`,
    previewCommunityLeaderboards: (id: string) =>
        `/communities/${id}/leaderboard-preview`,
    createCommunity: () => '/communities/create',
    communityChallenges: (id: string) => `/communities/${id}/challenges`,
    communityChallengeEditForm: (id: string, challengeId: string) =>
        `/communities/${id}/challenges/${challengeId}/edit`,
    communityChallengeLeaderboard: (id: string, challengeId: string) =>
        `/communities/${id}/challenges/${challengeId}/leaderboard`,
    challenges: () => '/challenges',
    challengeLeaderboard: (challengeId: string) =>
        `/challenges/${challengeId}/leaderboard`,
    communityChallengeCreateForm: (id: string) =>
        `/communities/${id}/challenges/create`,
    communityPointDefinitions: (id: string) =>
        `/communities/${id}/point-definitions`,
    createCommunityPointDefinition: (id: string) =>
        `/communities/${id}/point-definitions/create`,
    editCommunityPointDefinition: (id: string, definitionId: string) =>
        `/communities/${id}/point-definitions/${definitionId}/edit`,
    activityPointsRules: () => '/workout-rules/activity-points-rules',
    activityPointsRuleDetails: (id: string) =>
        `/workout-rules/activity-points-rules/${id}`,
    createActivityPointsRule: () =>
        '/workout-rules/activity-points-rules/create',
    editActivityPointsRule: (id: string) =>
        `/workout-rules/activity-points-rules/${id}/edit`,
    workoutTypeRules: () => '/workout-rules/workout-type-rules',
    createWorkoutTypeRule: () => '/workout-rules/workout-type-rules/create',
    editWorkoutTypeRule: (id: string) =>
        `/workout-rules/workout-type-rules/${id}/edit`,
    workoutTypeMappings: () => '/workout-rules/workout-type-mappings',
    calculatedMetricDefinitions: () => '/workout-rules/calculated-metrics',
    createCalculatedMetricDefinition: () =>
        '/workout-rules/calculated-metrics/create',
    editCalculatedMetricDefinition: (id: string) =>
        `/workout-rules/calculated-metrics/${id}/edit`,
    badges: () => '/badges',
    currencies: () => '/currencies'
};
